// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3OP2p","info":"PatientInfo_info__2E-co"};